import { FeatureCode, useGetCommunityDmStatusQuery } from 'generated/graphql';
import { resolveInfluencerId } from '../lib/resolveInfluencerId';

// Permission-style hook: returns a settled boolean rather than Async<T>. While
// the flag loads it reads as disabled by design, so the DM action stays hidden
// until confirmed. Data hooks use Async<T>; gate/permission hooks intentionally
// collapse loading to false.
export const useIsDmFeatureEnabled = (influencerId?: string): boolean => {
  const creatorId = resolveInfluencerId(influencerId);

  const { data } = useGetCommunityDmStatusQuery({
    variables: { id: creatorId ?? 0 },
    skip: creatorId === null,
  });

  return (data?.creator?.features ?? []).some(
    (feature) => feature?.code === FeatureCode.Dm,
  );
};
